import TransformComponent from '../../../Component/Transform';
import { Easing } from '@tweenjs/tween.js';
import AnimationClip from '../AnimationClip';
import { getCardHandler } from '../../Card/CardSystem';
import BaseCardHandler from '../../Card/Handler/BaseCardHandler';
import CardComponent from '../../../Component/Level/Card';
import BaseCard from '../../../Prototype/Level/Card/BaseCard';
import SpriteComponent from '../../../Component/Render/Sprite';
import Renderable from 'Component/Renderable';

interface ICardFlipMeta {
    scale?: number;
    rotation?: number;
    noCardSystem?: boolean;
    faceUp?: boolean;
    isPrebooster?: boolean;
    delay?: number;
}

export class CardFlip extends AnimationClip<ICardFlipMeta> {
    public *execute(
        gameObject: BaseCard,
        meta: ICardFlipMeta = {}
    ): IterableIterator<number> {
        const cardComponent = gameObject.getComponent(CardComponent);
        cardComponent.flipping = true;

        const transform: TransformComponent = gameObject.getComponent(
            TransformComponent
        );

        // Reset rotation.
        if (meta.rotation) {
            transform.rotation = meta.rotation;
        }
        const originalScale = meta.scale ?? transform.scale.x;

        const tweenIn = this.getTween(transform.scale);

        tweenIn.to({ x: 0 }, 150).easing(Easing.Quadratic.In).delay(meta.delay ?? 0);

        yield* this.startTween(tweenIn);
        const tweenOut = this.getTween(transform.scale);

        if (meta.noCardSystem) {
            this.gameObject
                .getChildByName('cardFrontSprite')
                .getComponent(SpriteComponent).visible = meta.faceUp;
            this.gameObject
                .getChildByName('cardBackSprite')
                .getComponent(SpriteComponent).visible = !meta.faceUp;
        } else {
            const handler: BaseCardHandler = getCardHandler(gameObject);
            handler.setCardFaceUp(meta.faceUp);
        }

        if(meta.isPrebooster) {
            gameObject.getArmature().getComponent(Renderable).alpha = 0;
        }

        tweenOut.to({ x: originalScale }, 150).easing(Easing.Quadratic.Out);

        yield* this.startTween(tweenOut);

        cardComponent.flipping = false;
    }
}
